var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspectionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80439 28.2593C3.87401 28.2593 2.98173 28.4778 2.32386 28.8667C1.66598 29.2557 1.29639 29.7833 1.29639 30.3333C1.29639 30.8834 1.66598 31.411 2.32386 31.7999C2.98173 32.1889 3.87401 32.4074 4.80439 32.4074V28.2593ZM96.0124 28.2593H4.80439V32.4074H96.0124V28.2593Z",
    fill: "#7EB3BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9998 4.66666L25.6665 30.3333M72.3332 4.66666L55.9998 30.3333M62.9998 60.6667C62.9998 57.7127 59.9105 55.72 53.7318 51.73C47.4692 47.6887 44.3378 45.668 41.9998 47.1567C39.6665 48.636 39.6665 52.6447 39.6665 60.6667C39.6665 68.6887 39.6665 72.6973 41.9998 74.1813C44.3332 75.6653 47.4692 73.6447 53.7318 69.6033C59.9105 65.6133 62.9998 63.6207 62.9998 60.6667Z",
    stroke: "#7EB3BD",
    strokeWidth: 3.45679,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6668 49C95.6668 70.9987 95.6668 81.998 88.8302 88.83C82.0028 95.6667 70.9988 95.6667 49.0002 95.6667C27.0015 95.6667 16.0022 95.6667 9.1655 88.83C2.3335 82.0027 2.3335 70.9987 2.3335 49C2.3335 27.0013 2.3335 16.002 9.1655 9.16533C16.0068 2.33333 27.0015 2.33333 49.0002 2.33333C70.9988 2.33333 81.9982 2.33333 88.8302 9.16533C93.3755 13.7107 94.8968 20.0993 95.4102 30.3333",
    stroke: "#7EB3BD",
    strokeWidth: 3.45679,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionLogo);
export default __webpack_public_path__ + "static/media/inspection-logo.2e9991aba04193825c13aad506fe0252.svg";
export { ForwardRef as ReactComponent };